import React from 'react';
import { Link } from 'react-router-dom';

const CanpactualService = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top driver">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2>Canpactual Staffing & Driver</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Canpactual Staffing & Driver</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

        </>
    )
}

export default CanpactualService;
